// extracted by mini-css-extract-plugin
module.exports = {"containerActions":"index__containerActions__20BWq","btnViewMarketplace":"index__btnViewMarketplace__27cF1","linkDetail":"index__linkDetail__YSPUM"};